<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="220"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_sevenData'"
    :sqOptions="[ 8, 9]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesSeven',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 60)
      } else if (value === 2) {
        this.$emit('handleProgress', 65)
      } else if (value === 3) {
        this.$emit('handleProgress', 58)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
